app.factory('logoutService', ['gameService', 'authService', 'appService', '$state', function(gameService, authService, appService, $state) {
	var service = this;

	service.restart = function() {
		gameService.resetGameState().then(function() {
			 if (authService.isTeacher) {
				$state.go('teacherapp');
			} else {
				$state.go('student');
			}
		});
	}

	service.logout = function() {
		authService.restart();
		gameService.restart();

		$state.go('student.login');

		appService.clearCookies();
	}

	return service;
}]);
